import { ArrowRightIcon } from "@heroicons/react/solid";
import React from "react";

export default function Navbar() {
  return (
    <header className="bg-secondary-300 md:sticky top-0 z-10">
      <div className="container mx-auto flex flex-wrap p-5 flex-col md:flex-row items-center">
        <img
            width="100px"
            alt="Logo"
            src="./logo.png"
          />
        <a className="title-font font-medium mb-4 md:mb-0">
          <a href="#about" className="ml-3 text-xl">
            Mattia Peretti
          </a>
        </a>
        <nav className="md:mr-auto md:ml-4 md:py-1 md:pl-4 md:border-l md:border-gray-700	flex flex-wrap items-center text-base justify-center">
          <a href="#projects" className="mr-5 hover:text-primary-200">
            Lavori
          </a>
          <a href="#skills" className="mr-5 hover:text-primary-200">
            Competenze
          </a>
          {/*
          <a href="#testimonials" className="mr-5 hover:text-white">
            Testimonianze
          </a>
          */}
        </nav>
        <a
          href="#contact"
          className="inline-flex items-center text-white bg-primary-400 border-0 py-1 px-3 focus:outline-none hover:bg-primary-500 rounded mt-4 md:mt-0">
          Ingaggiami
          <ArrowRightIcon className="w-4 h-4 ml-1" />
        </a>
      </div>
    </header>
  );
}
